import { render, staticRenderFns } from "./Radix36Input.vue?vue&type=template&id=700d6b6c&"
import script from "./Radix36Input.vue?vue&type=script&lang=ts&"
export * from "./Radix36Input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports